export default __webpack_public_path__ + "static/media/eye-off.206ce6ac.svg";